var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFront2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 10,
    fill: "#FFE6C1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#F9C579"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7035 26.6673C29.6262 25.3445 30.1673 23.7358 30.1673 22.0007C30.1673 21.3999 30.1025 20.8144 29.9794 20.2506M15.2978 26.6673C14.3751 25.3445 13.834 23.7358 13.834 22.0007C13.834 17.4903 17.4903 13.834 22.0007 13.834C22.4931 13.834 22.9754 13.8776 23.4439 13.9611M27.2505 16.7507L22.0005 22.0007M33.6673 22.0007C33.6673 28.444 28.444 33.6673 22.0007 33.6673C15.5573 33.6673 10.334 28.444 10.334 22.0007C10.334 15.5573 15.5573 10.334 22.0007 10.334C28.444 10.334 33.6673 15.5573 33.6673 22.0007ZM23.1673 22.0007C23.1673 22.645 22.645 23.1673 22.0007 23.1673C21.3563 23.1673 20.834 22.645 20.834 22.0007C20.834 21.3563 21.3563 20.834 22.0007 20.834C22.645 20.834 23.1673 21.3563 23.1673 22.0007Z",
    stroke: "#A26A1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFront2);
export default __webpack_public_path__ + "static/media/front-2.7078e24d470d12220a510e9f1fbc1e8d.svg";
export { ForwardRef as ReactComponent };